import React, { useState } from 'react';
import {
    Link as RouterLink,
    useLocation
} from 'react-router-dom';

import {
    Breadcrumbs,
    Typography,
    Box,
    Link,
    Menu,
    MenuItem
} from '@mui/material';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import FolderOpenRoundedIcon from '@mui/icons-material/FolderOpenRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';

const nomesRotas = {
    transparencia: 'TRANSPARÊNCIA',
    licitacoes: 'LICITAÇÕES',
    prefeitura: 'PREFEITURA',
    legislacao: 'LEGISLAÇÃO',
    arquivos: 'ARQUIVOS',
    mapadosite: 'MAPA DO SITE',
    vereadores: 'VEREADORES',
    secretarios: 'SECRETÁRIOS',

    editais: 'EDITAIS',
    contratos: 'CONTRATOS',
    ldo: 'LDO',
    loa: 'LOA',
    ppa: 'PPA',
    pca: 'PCA',
    rgf: 'RGF',
    rreo: 'RREO',
    quadro: 'QUADRO',
    concursos: 'CONCURSOS',
    semanario: 'SEMANÁRIO',
    frota: 'FROTA',
    farmaciabasica: 'FARMÁCIA BÁSICA',

    decretos: 'DECRETOS',
    leiorganica: 'LEI ORGÂNICA',
    portarias: 'PORTARIAS',
    requerimentos: 'REQUERIMENTOS',
    projetodelei: 'PROJETO DE LEI',
    mocoes: 'MOÇÕES',
    atas: 'ATAS',
    pareceres: 'PARECERES',
    resolucoes: 'RESOLUÇÕES',
    indicacoes: 'INDICAÇÕES',
    emendas_parlamentares: 'EMENDAS',
    decretos_legislativos: 'DEC. LEGISLATIVOS',
    pedidos_info: 'PEDIDOS DE INFO',
    diariosoficial: 'DIÁRIO OFICIAL',
    controleinterno: 'CONTROLE INTERNO',

    historia: 'HISTÓRIA',
    lgpd: 'LGPD',
    ouvidoria: 'OUVIDORIA',
    galeria: 'GALERIA',
    'e-sic': 'E-SIC',

    app: 'SERVIÇOS',
    perguntas: 'CONTATO',
    iptu: 'IPTU',
    notasfiscais: 'NOTAS FISCAIS',
    gurjaoplus: 'GURJÃO+',

    rh: 'RH',
    documentos: 'DOCUMENTOS',
    fichafuncional: 'FICHA FUNCIONAL',
    cc: 'CONTRACHEQUE',
    noticias: 'NOTÍCIAS'   // ← Adicionado
};

const menuMap = {
    '/arquivos': [
        '/mapadosite',
        '/arquivos/editais',
        '/arquivos/contratos',
        '/arquivos/ldo',
        '/arquivos/loa',
        '/arquivos/pca',
        '/arquivos/ppa',
        '/arquivos/frota',
        '/arquivos/quadro',
        '/arquivos/semanario',
        '/arquivos/concursos',
        '/arquivos/licitacoes',
        '/arquivos/farmaciabasica'
    ],

    '/legislacao': [
        '/mapadosite',
        '/legislacao/leiorganica',
        '/legislacao/decretos',
        '/legislacao/portarias',
        '/legislacao/requerimentos',
        '/legislacao/projetodelei',
        '/legislacao/mocoes',
        '/legislacao/atas',
        '/legislacao/pareceres',
        '/legislacao/resolucoes',
        '/legislacao/indicacoes',
        '/legislacao/emendas_parlamentares',
        '/legislacao/decretos_legislativos',
        '/legislacao/pedidos_info',
        '/legislacao/diariosoficial',
        '/legislacao/controleinterno'
    ],

    '/prefeitura': [
        '/mapadosite',
        '/historia',
        '/ouvidoria',
        '/e-sic',
        '/lgpd',
        '/carta-de-servico'
    ],

    '/app': [
        '/mapadosite',
        '/app/perguntas',
        '/app/iptu',
        '/app/notasfiscais',
        '/app/gurjaoplus'
    ],

    '/rh': [
        '/mapadosite',
        '/rh/documentos',
        '/rh/fichafuncional',
        '/rh/cc'
    ]
};
export default function Breadcrumb() {
    const location = useLocation();

    const [anchorEl, setAnchorEl] = useState(null);
    const [menuItems, setMenuItems] = useState([]);

    const pathnames = location.pathname
        .split('/')
        .filter(Boolean);

    if (!pathnames.length) return null;

    const openMenu = (event, path) => {
        setAnchorEl(event.currentTarget);
        setMenuItems(menuMap[path] || []);
    };

    const closeMenu = () => {
        setAnchorEl(null);
        setMenuItems([]);
    };

    // Verifica se é página de notícia (qualquer rota que comece com /noticias)
    const isNoticiaPage = location.pathname.startsWith('/noticias');

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    py: 2,
                    px: 2,
                    bgcolor: '#f7f9fc',
                    borderBottom: '1px solid #e5e7eb'
                }}
            >
                <Breadcrumbs
                    separator={
                        <NavigateNextIcon
                            sx={{
                                color: 'primary.main',
                                fontSize: 18
                            }}
                        />
                    }
                >
                    <Link
                        component={RouterLink}
                        to="/"
                        underline="none"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: .5,
                            fontWeight: 700,
                            textTransform: 'uppercase'
                        }}
                    >
                        <HomeRoundedIcon fontSize="small" />
                        Início
                    </Link>

                    {pathnames.map((value, index) => {
                        const to = '/' + pathnames.slice(0, index + 1).join('/');
                        const isLast = index === pathnames.length - 1;
                        const label = nomesRotas[value] || value.replace(/-/g, ' ').toUpperCase();
                        const hasMenu = menuMap[to];

                        // === TRATAMENTO ESPECIAL PARA NOTÍCIAS ===
                        if (isNoticiaPage) {
                            if (isLast) {
                                return (
                                    <Typography
                                        key={to}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: .5,
                                            fontWeight: 700,
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        Notícias
                                    </Typography>
                                );
                            }
                            return null; // Não mostra os segmentos intermediários
                        }

                        // Comportamento normal para as demais páginas
                        if (isLast) {
                            return (
                                <Typography
                                    key={to}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: .5,
                                        fontWeight: 700,
                                        textTransform: 'uppercase'
                                    }}
                                >
                                    <DescriptionRoundedIcon fontSize="small" />
                                    {label}
                                </Typography>
                            );
                        }

                        if (hasMenu) {
                            return (
                                <Link
                                    key={to}
                                    component="button"
                                    underline="none"
                                    onClick={(e) => openMenu(e, to)}
                                    sx={{
                                        border: 0,
                                        background: 'none',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: .5,
                                        color: 'text.secondary',
                                        fontWeight: 600,
                                        textTransform: 'uppercase'
                                    }}
                                >
                                    <FolderOpenRoundedIcon fontSize="small" />
                                    {label}
                                    <ArrowDropDownRoundedIcon />
                                </Link>
                            );
                        }

                        return (
                            <Link
                                key={to}
                                component={RouterLink}
                                to={to}
                                underline="none"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: .5,
                                    color: 'text.secondary',
                                    fontWeight: 600,
                                    textTransform: 'uppercase'
                                }}
                            >
                                <FolderOpenRoundedIcon fontSize="small" />
                                {label}
                            </Link>
                        );
                    })}
                </Breadcrumbs>
            </Box>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={closeMenu}
            >
                {menuItems.map((route) => {
                    const last = route.split('/').pop();
                    return (
                        <MenuItem
                            key={route}
                            component={RouterLink}
                            to={route}
                            onClick={closeMenu}
                        >
                            {nomesRotas[last] || last.toUpperCase()}
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
}